(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var EXCLUDED = [
    'shopify-section--parfumeurs',
    'shopify-section--main-product',
    'shopify-section--video'
  ];

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var img = entry.target;
      obs.unobserve(img);

      function reveal() {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            img.style.opacity = '1';
          });
        });
      }

      if (img.complete && img.naturalWidth > 0) {
        reveal();
      } else {
        img.addEventListener('load', reveal, { once: true });
        img.addEventListener('error', function () { img.style.opacity = '1'; }, { once: true });
      }
    });
  }, { threshold: 0.01, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.shopify-section').forEach(function (section) {
    if (EXCLUDED.some(function (cls) { return section.classList.contains(cls); })) return;
    section.querySelectorAll('img').forEach(function (img) {
      if (getComputedStyle(img).opacity === '0') return;
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.7s ease';
      observer.observe(img);
    });
  });
})();
